// Feature slices aggregator. Add your feature slices here.
import { createFirstTimeSetupSlice } from './FirstTimeSetup/slice';

export const createFeatureSlices = (set, get) => ({
  ...createFirstTimeSetupSlice(set, get),
});
